/**
 * @param {string} component Component name as string.
 * @returns {Promise} Returns a promise.
 */
export function asyncLoadRouter(component) {
  return () => import(`@views/container/${component}`)
}
